import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer>
      <a href='#' className='footer__logo'>Amir Ali</a>

      <ul className="permalinks">
        <li><a href='#'>Home</a></li>
        <lili><a href='#about'>About</a></lili>
        <li><a href='#experience'>Experience</a></li>
        <li><a href='#portfolio'>Portfolio</a></li>
        <li><a href='#contact'>Contact</a></li>
      </ul>

      <div className="footer__copyright">
        <small>&copy; Amir's Portfolio. All rights reserved.</small>
      </div>

      </footer>
  )
}

export default Footer
